/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/privacy-policy/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { renderPrivacyPolicyContent } from 'BomdisoftComponents/privacy-policy/render';

type PrivacyPolicyProps = {
  companyName: string;
  supportEmail: string;
  className?: string;
  testId?: string;
};

export const PrivacyPolicy = ({ companyName, supportEmail, className, testId }: PrivacyPolicyProps) => (
  <article className={joinClasses('bomdisoft-privacy-policy', className)} dangerouslySetInnerHTML={{ __html: renderPrivacyPolicyContent({ companyName, supportEmail }).value }} data-testid={testId} />
);
